import ValidSignFoldersCounter from './ValidSignFoldersCounter';

export default ValidSignFoldersCounter;
